/**
 * Utility classes to automatically work with enriched phone and emails.
 * Works with url only (tel: and mailto:) or full html tags.
 * Outputs the result depending on the given input. If it is a valid phone or email, it outputs the corresponding url or html.
 **/

type RichContactFieldModes = 'html' | 'url';

abstract class SmartContactFieldEnricher {
    urlProtocolName: string = 'unknown';
    protected regex: RegExp = /^\+?[\d\s\-()]{8,}$/;
    protected constructor(protected value: string, protected mode: RichContactFieldModes) {}
    public isValid(): boolean {
        const trimmed = this.value.trim();
        return this.regex.test(trimmed);
    }
    public toString(): string {
        if (this.isValid()) {
            const trimmed = this.value.trim();
            const url = `${this.urlProtocolName}:${trimmed}`;
            if (this.mode === 'url') return url;
            return `<a href="${url}">${trimmed}</a>`;
        }
        return this.value;
    }
}

export class SmartPhoneFieldEnricher extends SmartContactFieldEnricher {
    urlProtocolName = 'tel';
    regex = /^\+?[\d\s\-()]{8,}$/;

    static from(maybeFormattedPhone: string | undefined, mode: RichContactFieldModes = 'url'): SmartPhoneFieldEnricher | undefined {
        if (!maybeFormattedPhone) return undefined;
        return new SmartPhoneFieldEnricher(maybeFormattedPhone, mode);
    }
}

export class SmartEmailFieldEnricher extends SmartContactFieldEnricher {
    urlProtocolName = 'mailto';
    regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    static from(maybeFormattedEmail: string | undefined, mode: RichContactFieldModes = 'url'): SmartEmailFieldEnricher | undefined {
        if (!maybeFormattedEmail) return undefined;
        return new SmartEmailFieldEnricher(maybeFormattedEmail, mode);
    }
}
